export default __webpack_public_path__ + "static/media/Competition_white.286c2cec.svg";